























































import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import moment from 'moment';
import { World, SocketState, User } from '@/types';
import api from '@/api';
import ActivityIndicator from '@/components/ActivityIndicator.vue';
import Travel from '@/components/world/Travel.vue';
import Games from '@/components/world/Games.vue';
import Leaderboards from '@/components/world/Leaderboards.vue';
import { TweenLite, Elastic } from 'gsap';

@Component({
  components: {
    ActivityIndicator,
    Games,
    Travel,
    Leaderboards,
  },
})
export default class Main extends Vue {
  @State public socket!: SocketState;
  @State public world!: World;
  @State public user!: User;

  public view = 'travel';

  public mounted() {
    const { view } = this.$route.params;
    if (view === 'games' || view === 'travel') {
      this.view = view;
    } else {
      this.$router.replace('/world/travel');
      this.view = 'travel';
    }

    // fade in
    TweenLite.fromTo(document.getElementById('side-menu'), 1.5, { x: '150%' }, { x: '0%', ease: Elastic.easeOut.config(1, 0.5), });
    TweenLite.fromTo(document.getElementById('display'), 1, { opacity: 0 }, { opacity: 1 });
  }
  public setView(view: string) {
    if (this.view === view) {
      return;
    }
    // fade out
    TweenLite.fromTo(document.getElementById('side-menu'), 0.75, { x: '0%' }, { x: '150%', ease: Elastic.easeIn.config(0.5, 0.5), });
    TweenLite.fromTo(
      document.getElementById('display'),
      1,
      { opacity: 1 },
      { opacity: 0,
        onComplete: () => {
          this.view = view;
          this.$router.replace(`/world/${view}`);
          // fade in
          TweenLite.fromTo(document.getElementById('side-menu'), 1.5, { x: '150%' }, { x: '0%', ease: Elastic.easeOut.config(1, 0.5), });
          TweenLite.fromTo(document.getElementById('display'), 1, { opacity: 0 }, { opacity: 1 });
        }
      }
    );
  }
  public setGame(name: string) {
    this.$router.push(name);
  }
  get readableTimeOfDay() {
    return moment(this.world.timeOfDay).format('LT'); ;
  }
  get currentlyOnline() {
    return Object.keys(this.world.connectedUsers).length
  }
}
